import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { UserPlus } from 'lucide-react';

const GuestSignupBanner = () => {
  const { isGuestMode } = useAuth();
  const navigate = useNavigate();

  if (!isGuestMode) return null;

  return (
    <div className="sticky top-0 z-50 bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-4 py-2.5 flex items-center justify-center gap-3 shadow-md" data-testid="guest-signup-banner">
      <span className="text-sm font-medium">You're previewing PlanBlox</span>
      <Button
        size="sm"
        variant="secondary"
        className="rounded-full bg-white text-emerald-700 hover:bg-emerald-50 font-semibold text-xs px-4 h-7"
        onClick={() => navigate('/register')}
        data-testid="guest-signup-banner-btn"
      >
        <UserPlus className="h-3.5 w-3.5 mr-1.5" />
        Sign up to unlock — get 5 free credits
      </Button>
    </div>
  );
};

export default GuestSignupBanner;
